<template>
  <div class="container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>待办时间轴</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="handleAdd">添加</el-button>
      </div>
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in data"
          :key="index"
          :timestamp="activity.create_time">
          <el-card shadow="never">
            <el-row>
              <el-col :span="16">
                <div> 待办时间：{{ activity.date }} </div>
                <div> 待办状态：{{ activity.status | formatStatus }} </div>
                <el-tooltip effect="dark" :content="activity.content" placement="bottom">
                  <div class="text-wrapper">
                    待办内容：{{ activity.content }}
                  </div>
                </el-tooltip>
              </el-col>

              <el-col :span="8">
                <el-row type="flex" justify="end">
                  <el-button :type="isDisabled(activity) ? '' : 'primary'" size="small" @click="handleEdit(activity)"> {{ getListButtonText(activity) }}</el-button>
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-card>
    
    <el-dialog 
      :title="isAdd ? '新增' : '编辑'"
      :visible.sync="showEditForm"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleEditFormDialogClose"
    >

      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right">
        
        <el-form-item prop="content" label="内容:" label-width="150px">
          <el-input v-model="editForm.content" type="textarea" :rows="10" style="width:80%" :disabled="!isAdd" />
        </el-form-item>

        <el-form-item v-if="isAdd" prop="date" label="时间:" label-width="150px">
          <el-date-picker
            v-model="editForm.date"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:80%"
            :picker-options="pickerOptions"
            :disabled="!isAdd"
            editable
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item v-else label="时间:" label-width="150px">
          <el-input v-model="editForm.date" style="width:80%" disabled />
        </el-form-item>

        <el-form-item v-if="!isAdd" prop="status" label="状态:" label-width="150px">
          <el-select
            v-model="status"
            placeholder="请选择"
            style="width:80%"
            :disabled="!isDisabled('')"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditForm = false">取 消</el-button>
        <el-button v-if="isAdd" type="primary" @click="handleSaveAdd"> 确 定 </el-button>
        <el-button v-else-if="isDisabled('')" type="primary" @click="handleSaveUpdate"> 处 理 </el-button>
        <el-button v-else-if="this.editForm.status !== 910" type="danger" @click="handleInvalid"> 作 废 </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  const initForm = {
    content: null,
    date: null,
    status: null
  },
  checkTime = (rule, value, callback) => {
    if (!value) {
      callback(new Error("时间不能为空"));
    }
    const isPastTimes = new Date(value).getTime() > new Date().getTime() ? false : true;
    if (isPastTimes) {
      callback(new Error("选择时间需要大于当前时间"));
    } else {
      callback();
    }
  },
  initRules = {
    content: [
      {
          required: true,
          message: "内容不能为空"
      }
    ],
    date: [
      {
        required: true,
        validator: checkTime,
        message: "",
        trigger: "blur"
      }
    ], 
    status: [
      {
        required: true,
        message: "状态不能为空"
      }
    ]
  },

  initStatusList = [
    { name: '创建', value: 0 },
    { name: '处理中', value: 100 },
    { name: '处理完成', value: 900},
    { name: '作废', value: 910}
  ]

  export default {
    name: 'PendingTimeline',
    components: {  },
    props: {
      data: {
        type: Array,
        default: null
      },
      showEdit: {
        type: Boolean,
        default: false
      }
    },
    filters: {
      formatStatus(value) {
        const status = initStatusList.find(item => item.value === value)
        return status ? status.name : ''
      }
    },
    data () {
      return {
        reverse: true,
        editForm: { ...initForm },
        statusList: { ...initStatusList },
        isAdd: false,
        status: null,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      }
    },
    computed: {
      editRules: function () {
          return { ...initRules }
      },
      showEditForm: {
        get() {
          return this.showEdit
        },
        set(v) {
          this.$emit('change-show', v)
        }
      }
    },
    created() {
      
    },
    methods: {
      handleAdd() {
        this.isAdd = true
        this.showEditForm = true
      },
      handleEdit(row) {
        this.isAdd = false
        this.editForm = { ...row }
        this.status = this.editForm.status
        this.showEditForm = true
      },
      handleSaveAdd() {
        this.$refs.editForm.validate(val => {
          if (val) {
            this.$emit('change-save', { content: this.editForm.content, date: this.editForm.date})
          }
        })
      },
      handleSaveUpdate() {
        this.$refs.editForm.validate(val => {
          if (val) {
            this.$emit('change-save', { event_id: this.editForm.event_id, status: this.status})
          }
        })
      },
      handleInvalid() {
        this.$refs.editForm.validate(val => {
          if (val) {
            this.$confirm("是否作废'" + this.editForm.date + '内容：' + this.editForm.content + "'的事件？").then(() => {
              this.$emit('change-save', { event_id: this.editForm.event_id, status: 910})
            })
          }
        })
      },
      handleEditFormDialogClose() {
        this.isAdd = false
        this.editForm = { ...initForm }
        this.$refs.editForm.clearValidate()
      },
      isDisabled(activity) {

        if (activity.status === 910) {
          return true
        }
        
        if (activity.date) {
          return Date.parse(activity.date) > new Date()
        }

        if (this.editForm.event_id && this.editForm.status !== 910) {
          return Date.parse(this.editForm.date) <= new Date()
        }

        return this.isAdd
      },
      getListButtonText(row) {
        if (Date.parse(row.date) <= new Date()) {
          if (row.status === 0) {
            return '开始处理'
          } else if (row.status === 100) {
            return '处理中'
          } else if (row.status === 900) {
            return '处理完成'
          }
        }
        return '查 看'
      }
    }
  }
</script>
<style scoped>
.container {
  margin-top: 10px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}

.text-wrapper {
  margin-top: 5px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
}
</style>